import { useSearchParams } from '@remix-run/react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { sendAnalyticsEvent } from '~/lib/analytics.client';
import { SUBSCRIPTION_UPDATE_SEARCH_PARAM } from '~/lib/stores/pricing/config';
import { userStore } from '~/lib/stores/user';
import { AnalyticsAction, AnalyticsTrackEvent } from '~/types/analytics';
import { SUBSCRIPTION_ACTIVATED_MESSAGE } from '~/utils/constants';

export const useSubscriptionActivateMessage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const messageType = searchParams.get(SUBSCRIPTION_UPDATE_SEARCH_PARAM);

  useEffect(() => {
    if (!messageType) {
      return;
    }

    const newParams = new URLSearchParams(searchParams);
    newParams.delete(SUBSCRIPTION_UPDATE_SEARCH_PARAM);
    setSearchParams(newParams);

    toast.success(SUBSCRIPTION_ACTIVATED_MESSAGE);

    // track TeamCheckoutCompleted when user returns from successful checkout
    const user = userStore.user.get();
    const activeOrganization = userStore.getActiveOrganization().get();

    if (activeOrganization?.billing?.subscription) {
      sendAnalyticsEvent({
        action: AnalyticsAction.Track,
        payload: {
          event: AnalyticsTrackEvent.TeamCheckoutCompleted,
          properties: {
            organization_id: activeOrganization.id,
            organization_slug: activeOrganization.slug,
            final_plan_level: activeOrganization.billing.tier,
            final_interval: activeOrganization.billing.subscription.interval,
            final_member_count: activeOrganization.billing.subscription.quantity || 1,
            subscription_status: activeOrganization.billing.subscription.status,
            user_id: user?.id,
            user_email: user?.email,
          },
        },
      });
    }
  }, [messageType]);
};
